export default __webpack_public_path__ + "static/media/manual.ac9a22cd.svg";